import axios from 'axios';
import qs from 'qs';
import utils from 'shared/helpers/utils';

const UAA_URL = process.env.REACT_APP_UAA_URL;
const UAA_APP_NAME = process.env.REACT_APP_AUTH_APP_NAME;
const SMART_CLIENT_API = process.env.REACT_APP_SMART_CLIENT_DATA;
const PRODUCT_CATALOGUE_API = process.env.REACT_APP_CATALOGUE_SCREENER_API;
const PAYMENT_API = process.env.REACT_APP_PAYMENT;
const CALCULATE_API = process.env.REACT_APP_CALCULATE_AMOUNT_UNIT;

/**
 * Request an OTP to aunthenticate a phone number
 * @param phoneNumber
 * @param email address
 */
const requestOTP = async (phoneNumber, email, isEmailAuth = false, captchaToken) => {
  try {
    const data = {
      channel: 'markaz',
      username: phoneNumber,
      email,
      otpType: isEmailAuth ? 'email' : 'phone',
      captchaToken,
    };
    const options = {
      method: 'POST',
      headers: { 'content-type': 'application/x-www-form-urlencoded', channel: 'markaz-usr', appName: UAA_APP_NAME },
      data: qs.stringify(data),
      url: `${UAA_URL}/markaz/otp`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

/**
 * Verify the OTP
 * @param {*} username : phoneNumber
 * @param {*} otp
 * @param {*} email
 * @returns token
 */
const verifyOTP = async (username, otp, email, tokenCaptcha, otpType) => {
  try {
    const data = {
      channel: 'markaz', username, email, password: otp, captchaToken: tokenCaptcha, otpType,
    };
    const options = {
      method: 'POST',
      headers: { 'content-type': 'application/x-www-form-urlencoded', channel: 'markaz-usr', appName: UAA_APP_NAME },
      data: qs.stringify(data),
      url: `${UAA_URL}/otp/login`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

/**
 * Signout (Clear token)
 * @param {*} token
 */
const requestLogout = async (token) => {
  const formData = new FormData();
  formData.append('token', token);
  formData.append('channel', 'markaz');

  try {
    // const data = formData;
    const options = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        channel: 'markaz-usr',
        appName: UAA_APP_NAME,
      },
      data: formData,
      url: `${UAA_URL}/quit`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

/**
 * Validate user token
 * Check if token is still valid on the back
 * @param {*} token
 */
const validateToken = async (token) => {
  try {
    const options = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        channel: 'markaz-usr',
        appName: UAA_APP_NAME,
      },
      url: `${UAA_URL}/auth/token`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

/**
 * Get Intenationalization
 * @param {*} token
 * @returns object of EN (englis) and AR (arabic)
 */
const getIntl = async (token) => {
  try {
    const options = {
      method: 'GET',
      headers: { Authorization: `Bearer: ${token}` },
      url: `${SMART_CLIENT_API}/markaz/i18n/v2`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

/**
 * Get Form Options
 * @param {*} token
 */
const getInitOptions = async (token) => {
  try {
    const options = {
      method: 'GET',
      headers: { Authorization: `Bearer: ${token}` },
      url: `${SMART_CLIENT_API}/markaz/initialize-data/v2`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

/**
 * Create/ POST application
 * @param {*} phoneNumber
 * @param {*} token
 */
const createApplicant = async (phoneNumber, token) => {
  try {
    const options = {
      method: 'POST',
      headers: {
        Authorization: `Bearer: ${token}`,
        Applicant: phoneNumber,
      },
      // data: qs.stringify(data),
      url: `${SMART_CLIENT_API}/markaz/applicant`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};
// TODO : get ip
const updateHistory = async (token, phoneNumber, appId, otpTime, ip, code, codeI18n) => {
  try {
    const today = new Date();

    const options = {
      method: 'POST',
      headers: {
        Authorization: `Bearer: ${token}`,
        principal: phoneNumber,
      },
      data: {
        actionTime: today.getTime(),
        otpAuthTime: otpTime,
        ipAddress: ip,
        applicantId: appId,
        actionTypeCode: code,
        actionTypeName: codeI18n,
      },
      url: `${SMART_CLIENT_API}/applicant/otp/time`,
    };


    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

const updateApplicant = async (applicantId, phoneNumber, token, data, isGenerate, locale = 'EN', signed) => {
  try {
    // const convertedData = {
    //   ...data,
    //   investmentExp: [
    //     {
    //       assetClass: 'NW-MAR-ASC-BOND',
    //       strategy: data.clientProfileForm.ieBondsStrategy,
    //       years: data.clientProfileForm.ieBondsYrs,
    //     },
    //     {
    //       assetClass: 'NW-MAR-ASC-EQU',
    //       strategy: data.clientProfileForm.ieEquitiesStrategy,
    //       years: data.clientProfileForm.ieEquitiesYrs,
    //     },
    //     {
    //       assetClass: 'NW-MAR-ASC-REAL',
    //       strategy: data.clientProfileForm.ieRealEstateStrategy,
    //       years: data.clientProfileForm.ieRealEstateYrs,
    //     },
    //     {
    //       assetClass: 'NW-MAR-ASC-ALT',
    //       strategy: data.clientProfileForm.ieOtherAlternativeInvestmentsStrategy,
    //       years: data.clientProfileForm.ieOtherAlternativeInvestmentsYrs,
    //     },
    //     {
    //       assetClass: 'NW-MAR-ASC-EAH',
    //       strategy: data.clientProfileForm.iePrivateEquityHedgeFundsStrategy,
    //       years: data.clientProfileForm.iePrivateEquityHedgeFundsYrs,
    //     },
    //   ],
    // };
    const convertedData = utils.investmentExp(data);
    const options = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer: ${token}`,
        principal: phoneNumber,
      },
      data: convertedData,
      url: `${SMART_CLIENT_API}/markaz/applicant/${applicantId}?lang=${locale}${isGenerate ? '&pdf=true' : ''}${signed ? '&signed=true' : ''}`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

/**
 * GET Qualified Applicant's Agreement Status
 * @return true or false
 */
const getQualifiedAgreementStatus = async (token, principal) => {
  try {
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        principal,
      },
      url: `${SMART_CLIENT_API}/markaz/applicant/agreement/status`,
    };
    const response = await axios(options);
    return response.data;
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

/**
 * Generate PACI (Kuwait Mobile ID) QR request
 * @param callbackUrl : where PACI will redirect the user after approving on the mobile app
 * @returns QR link and requestId
 */
const generatePaciQr = async (token, phoneNumber, applicantId, callbackUrl) => {
  try {
    const options = {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}`, principal: phoneNumber },
      url: `${SMART_CLIENT_API}/markaz/applicant/${applicantId}/qr?callback=${encodeURIComponent(callbackUrl)}`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

/**
 * Get the PACI (Kuwait Mobile ID) data the backend received for the QR request
 * @param requestId : from the generate QR response
 * @returns PACI result (Success, CivilId, FullNameEn, NationalityEn, BirthDate, ...)
 */
const pollPaciResult = async (token, phoneNumber, requestId) => {
  try {
    const options = {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}`, principal: phoneNumber },
      url: `${SMART_CLIENT_API}/paci/poll?requestId=${encodeURIComponent(requestId)}`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

/** GET THE UPLOADED CUSTOM SUB PORTFOLIO */
const getCustomSubPF = async (token, applicantId, phoneNumber, locale) => {
  try {
    const options = {
      method: 'GET',
      headers: { Authorization: `Bearer: ${token}`, principal: phoneNumber },
      url: `${SMART_CLIENT_API}/markaz/applicant/${applicantId}/custom/sub-pf?lang=${locale}`,
    };
    const response = await axios(options);

    // Create a Blob from the PDF Stream
    const file = new Blob(
      [response.data],
      { type: 'application/pdf' },
    );

    // Build a URL from the file
    const fileURL = response.data.size === 0 ? null : URL.createObjectURL(file);

    return Promise.resolve(fileURL);
  } catch ({ response }) {
    return Promise.reject((response && response) || 'An error occurred');
  }
};

const getPdfByPage = async (token, appAata, from, to, appPrincipal, type, specialType, locale) => {
  try {
    const options = {
      method: 'POST',
      headers: { Authorization: `Bearer: ${token}`, principal: appPrincipal },
      data: appAata,
      url: `${SMART_CLIENT_API}/markaz/applicant/pdf/partial?from=${from}&to=${to}&type=${type}&lang=${locale}&specialType=${specialType}`,
    };
    const response = await axios(options);
    // Create a Blob from the PDF Stream
    const file = new Blob(
      [response.data],
      { type: 'application/pdf' },
    );

    // Build a URL from the file
    const fileURL = response.data.size === 0 ? null : URL.createObjectURL(file);

    return Promise.resolve(fileURL);
  } catch ({ response }) {
    return Promise.reject((response && response) || 'An error occurred');
  }
};

const getPdfBeforeTandC = async (token, appAata, locale) => {
  try {
    const options = {
      method: 'POST',
      headers: { Authorization: `Bearer: ${token}` },
      data: appAata,
      url: `${SMART_CLIENT_API}/markaz/applicant/pdf/partial/before-terms-condition?lang=${locale}`,
    };
    const response = await axios(options);
    // Create a Blob from the PDF Stream
    const file = new Blob(
      [response.data],
      { type: 'application/pdf' },
    );

    // Build a URL from the file
    const fileURL = URL.createObjectURL(file);

    return Promise.resolve(fileURL);
  } catch ({ response }) {
    return Promise.reject((response && response) || 'An error occurred');
  }
};

const getApplicant = async (phoneNumber, token, productCode, withRefProductCode) => {
  try {
    const url = productCode && withRefProductCode ? `${SMART_CLIENT_API}/markaz/applicant/details?refCode=${productCode}` : `${SMART_CLIENT_API}/markaz/applicant/details`;
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer: ${token}`,
        principal: phoneNumber,
      },
      url,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

const getApplicantPdfStatus = async (phoneNumber, token) => {
  try {
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer: ${token}`,
        principal: phoneNumber,
      },
      url: `${SMART_CLIENT_API}/markaz/applicant/pdf/status`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

const resetApplicant = async (phoneNumber, token) => {
  try {
    const options = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer: ${token}`,
        principal: phoneNumber,
      },
      url: `${SMART_CLIENT_API}/markaz/applicant/reset`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

const createApplicantProgress = async (applicantId, token, data) => {
  try {
    const options = {
      method: 'POST',
      headers: {
        Authorization: `Bearer: ${token}`,
      },
      data,
      url: `${SMART_CLIENT_API}/applicant/${applicantId}/progress`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

const getApplicantProgress = async (applicantId, token) => {
  try {
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer: ${token}`,
      },
      url: `${SMART_CLIENT_API}/applicant/${applicantId}/progress`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

const resetApplicantProgress = async (applicantId, token) => {
  try {
    const options = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer: ${token}`,
      },
      url: `${SMART_CLIENT_API}/applicant/${applicantId}/progress`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

const getApplicantPDF = async (phoneNumber, token, locale) => {
  try {
    const url = `${SMART_CLIENT_API}/markaz/applicant/pdf?locale=${locale}&token=${token}`;
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer: ${token}`,
        principal: phoneNumber,
      },
      // responseType: 'blob',
      url,
    };
    const response = await axios(options);

    // // Create a Blob from the PDF Stream
    // const file = new Blob(
    //   [response.data],
    //   { type: 'application/pdf' },
    // );

    // // Build a URL from the file
    // const fileURL = URL.createObjectURL(file);
    if (!response.data) throw new Error();

    return Promise.resolve(url);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

/**
 * Get PDF based on PDF type
 * Can be use also to get each pdf
 * @param {*} phoneNumber
 * @param {*} token
 * @param {*} pdfType (Currently used to generate: mft, aa, dpf-absolute, dpf-sharia)
 */
const getOtherPDF = async (phoneNumber, token, pdfType, locale = 'EN') => {
  try {
    const url = `${SMART_CLIENT_API}/markaz/applicant/pdf/${pdfType}?lang=${locale}&token=${token}`;
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer: ${token}`,
        principal: phoneNumber,
      },
      url,
    };
    const response = await axios(options);
    // Create a Blob from the PDF Stream
    // const file = new Blob(
    //   [response.data],
    //   { type: 'application/pdf' },
    // );

    // // Build a URL from the file
    // const fileURL = URL.createObjectURL(file);

    // return Promise.resolve(fileURL);
    if (!response.data) throw new Error();

    return Promise.resolve(url);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

/**
 * Get the list of filenames uploaded by MO admin
 * and use this array to generate the custom sub agreement based on filename
 * @param {*} phoneNumber
 * @param {*} token
 */
const getAllUploadedFilenames = async (phoneNumber, token, locale) => {
  try {
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        principal: phoneNumber,
      },
      url: `${SMART_CLIENT_API}/markaz/applicant/custom/filenames?lang=${locale}`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

/**
 * Get uploaded custom sub agreement by filename ()
 * @param {*} phoneNumber
 * @param {*} token
 * @param {*} filename
 */
const getUploadedCustomFileByFilename = async (phoneNumber, token, filename, locale) => {
  try {
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        principal: phoneNumber,
      },
      url: `${SMART_CLIENT_API}/markaz/applicant/asset/file?fileName=${filename}&lang=${locale}`,
    };
    const response = await axios(options);

    // Create a Blob from the PDF Stream
    const file = new Blob(
      [response.data],
      { type: 'application/pdf' },
    );

    // Build a URL from the file
    const fileURL = URL.createObjectURL(file);

    return Promise.resolve(fileURL);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

const sendEmail = async (phoneNumber, token, locale) => {
  try {
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer: ${token}`,
        principal: phoneNumber,
      },
      url: `${SMART_CLIENT_API}/markaz/applicant/email?lang=${locale}`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

const sendNotificationAfterSign = async (phoneNumber, token, locale) => {
  try {
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer: ${token}`,
        principal: phoneNumber,
      },
      url: `${SMART_CLIENT_API}/markaz/applicant/email?withAgreement=false&lang=${locale}`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

const sendPaymentRequest = async (token, orderId, dataObj) => {
  try {
    const options = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: dataObj,
      url: `${PAYMENT_API}/proceed?orderId=${orderId}&paymentType=1`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

const getPaymentHistory = async (token) => {
  try {
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: `${PAYMENT_API}/result/history`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

const parsePaymentResult = async (
  token,
  data,
  productId,
) => {
  try {
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: `${PAYMENT_API}/${productId}/result/?data=${data}`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

const getIpAddress = async () => {
  const apiKey = 'at_oX6DgJPUWhga53sYVjdgzzw9DBCG6';
  const url = 'https://geo.ipify.org/api/v1';
  try {
    const options = {
      method: 'GET',
      url,
      params: {
        apiKey,
        reverseIp: 1,
      },
      // url: 'https://api.ipdata.co/?api-key=96e12e46b8a0cecf68261f1ed4fc552b90f5a9fbfda48b89b9d25b19',
    };

    const rs = await axios(options);
    return rs.data.ip;
  } catch (e) {
    console.log(e);
    return '';
  }
};

/** Fetch Catalogue List */
const getCatalogueScreener = async (token) => {
  try {
    const options = {
      method: 'GET',
      headers: {
        key: 'NWW##&*$@!1116',
        channel: 'markaz',
        Authorization: `Bearer ${token}`,
      },
      url: `${PRODUCT_CATALOGUE_API}/all?page=-1`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

const getPdfDocForDocuSign = async (urlString, token, phoneNumber) => {
  try {
    const options = {
      method: 'GET',
      url: `${SMART_CLIENT_API}/${urlString}`,
      headers: {
        Authorization: `Bearer: ${token}`,
        principal: phoneNumber,
      },
    };
    const response = await axios(options);
    const file = new Blob(
      [response.data],
      { type: 'application/pdf' },
    );
    const fileURL = response.data.size === 0 ? null : URL.createObjectURL(file);
    return Promise.resolve(fileURL);
  } catch ({ response }) {
    return Promise.reject((response && response) || 'An error occurred');
  }
};

const getCalculateInvestAmount = async (productCode, amount) => {
  try {
    const newAmount = parseFloat(amount.replace(/,/g, ''));
    const options = {
      method: 'GET',
      url: `${CALCULATE_API}/${productCode}?investedAmount=${newAmount}`,
    };
    const response = await axios(options);
    return Promise.resolve(response.data);
  } catch ({ response }) {
    return Promise.reject((response && response.data) || 'An error occurred');
  }
};

const apiRequest = {
  // Auth
  requestOTP,
  verifyOTP,
  validateToken,
  requestLogout,

  // i18n, masterData
  getIntl,
  getInitOptions,

  // Applicant
  createApplicant,
  updateApplicant,
  getApplicant,
  resetApplicant,

  createApplicantProgress,
  getApplicantProgress,
  resetApplicantProgress,
  getQualifiedAgreementStatus,

  getApplicantPDF,
  getOtherPDF,
  getApplicantPdfStatus,

  updateHistory,
  sendEmail,
  getIpAddress,
  getPdfByPage,
  getPdfBeforeTandC,
  sendNotificationAfterSign,

  getAllUploadedFilenames,
  getUploadedCustomFileByFilename,

  getCustomSubPF,

  generatePaciQr,
  pollPaciResult,

  getCatalogueScreener,

  sendPaymentRequest,
  parsePaymentResult,
  getPaymentHistory,

  getPdfDocForDocuSign,

  getCalculateInvestAmount,
};

export default apiRequest;
